import React, { useEffect, useState } from "react";
import Tabs from "../../Tabs";
import { AddFlex, Gap } from "../../reusableStyles";
import InstaCommentToDmAutomation from "./InstaCommentToDmAutomation";
import InstaDmAutomation from "./InstaDmAutomation";
import { BoxedTabs } from "../../Pages/OfferingsPages/OfferingPagesTabHeader";
import { callNonStoreApi } from "../../NonStoreApis";
import { FetchClientDmAutomation } from "../../Api/ApiEndPoints";
import useWindowSize from "../../Hooks/useWindowSize";
import { useSelector } from "react-redux";
import AiInstaDmAutomation from "./AiInstaDmAutomation";

function InstaAutomations() {
  const { isMobileView } = useWindowSize();
  const { credentials } = useSelector((state) => state.instagram);
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [button, setButton] = useState(null);
  const [instaAutomationData, setInstaAutomationData] = useState({});

  const getComponent = () => {
    switch (tabIndex) {
      case 0:
        return <InstaCommentToDmAutomation />;
      case 1:
        return (
          <InstaDmAutomation
            setButton={setButton}
            dmAutomation={instaAutomationData.dmAutomation}
          />
        );
      case 2:
        return <AiInstaDmAutomation />;
    }
  };

  const handleGetInitialData = async () => {
    const instaDmAutomationResponse = await callNonStoreApi(
      FetchClientDmAutomation,
      {
        instaUserId: credentials.user_id,
        instaId: credentials.id,
      }
    );
    setInstaAutomationData({
      dmAutomation: instaDmAutomationResponse.data.dmAutomation,
    });
    setLoading(false);
  };

  const getButton = () => {
    const { Component, props, children } = button;
    if (children) {
      return <Component {...props}>{children}</Component>;
    }
    return <Component {...props} />;
  };

  useEffect(() => {
    if (credentials) handleGetInitialData();
  }, [credentials]);

  useEffect(() => {
    return () => {
      setButton(null);
    };
  }, [tabIndex]);

  return loading ? (
    <></>
  ) : (
    <AddFlex
      flexDirection="column"
      padding={isMobileView() ? "0 20px 20px 20px" : "0 48px"}
      margin={isMobileView() ? "0px" : "20px 0"}
      style={{ height: "100%" }}
    >
      <AddFlex>
        <BoxedTabs
          selectedTabIndex={tabIndex}
          setSelectedTabIndex={setTabIndex}
          tabs={["Comment Automations", "DM Automations", "Growezy AI (BETA)"]}
        />
        <Gap />
        {button && !isMobileView() && getButton()}
      </AddFlex>
      {getComponent()}
    </AddFlex>
  );
}

export default InstaAutomations;
